var BrowseContentHelper, DealsApplication, DealsGTMHelper, DealsSearchParamsHelper, Page, performSearch, updateSeoPageMetaHash,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsSearchParamsHelper = require('./helpers/search_params');

DealsGTMHelper = require('./helpers/gtm-update');

BrowseContentHelper = require('../../browse/frontend/helpers/content');

updateSeoPageMetaHash = require('../../seo/frontend/page_meta_updater').updateSeoPageMetaHash;

Page = (function() {
  function Page(pageNumber, data) {
    var paginationData, ref, ref1;
    paginationData = data.metadata.pagination || {};
    _.extend(this, {
      clearanceDealsCount: data.clearanceDealsCount,
      countHtml: paginationData.countHtml,
      totalDealCount: paginationData.availableCount,
      bloodhoundHtml: paginationData.bloodhoundHtml,
      dealCount: paginationData.dealsCount,
      dealIdList: ((ref = data.metadata) != null ? (ref1 = ref.pagination) != null ? ref1.dealIdList : void 0 : void 0) || [],
      dealsHtml: data.dealsHtml,
      featuredHtml: data.featuredHtml,
      carouselHtml: data.carouselHtml,
      topDealsHtml: data.topDealsHtml,
      nextPageSize: paginationData.nextPageSize,
      number: pageNumber,
      totalPages: paginationData.totalPages,
      facets: data.metadata.facets,
      firstDeal: data.metadata.firstDeal,
      startingIndex: paginationData.startingIndex,
      endingIndex: paginationData.endingIndex,
      refinementUiPageData: data.refinementUiPageData,
      cardsHtml: data.cardsHtml,
      seoMetaHash: data.seoMetaHash,
      breadcrumbHash: data.breadcrumbHash
    });
  }

  return Page;

})();

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/partial',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (textStatus !== "abort") {
        return search.trigger('error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsApplication = (function() {
  function DealsApplication(options) {
    var dealsSearch;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.params = DealsSearchParamsHelper.getBaseParams(options);
    this._searchedServerSide = false;
    this._pageNumber = isNaN(Number(this.params.page)) ? 1 : Number(this.params.page);
    if (!/^\d+$/.test(this.params.minPrice)) {
      delete this.params.minPrice;
    }
    if (!/^\d+$/.test(this.params.maxPrice)) {
      delete this.params.maxPrice;
    }
    if ((this.params.minPrice != null) && (this.params.maxPrice != null) && parseInt(this.params.minPrice, 10) > parseInt(this.params.maxPrice, 10)) {
      delete this.params.minPrice;
      delete this.params.maxPrice;
    }
    if (!options.pageData) {
      if (options.pageNumber != null) {
        _.extend(this.params, {
          page: options.pageNumber
        });
        this._pageNumber = options.pageNumber;
      }
      this._dealsCount = options.dealsCount;
      this._startingIndex = options.startingIndex;
      dealsSearch = performSearch(this.params);
      dealsSearch.on('error', this._triggerErrorHandler);
      dealsSearch.on('success', this._triggerSuccessHandler);
    } else {
      this.page = new Page(this._pageNumber, options.pageData);
      this._searchedServerSide = true;
      null;
    }
  }

  DealsApplication.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsApplication.prototype.unfilteredParams = function() {
    return unfilteredParams(this.params);
  };

  DealsApplication.prototype.getPageNumber = function() {
    var ref;
    return ((ref = this.page) != null ? ref.number : void 0) || this._pageNumber;
  };

  DealsApplication.prototype.getDealsCount = function() {
    var ref;
    return ((ref = this.page) != null ? ref.dealCount : void 0) || this._dealsCount;
  };

  DealsApplication.prototype.getStartingIndex = function() {
    var ref;
    return ((ref = this.page) != null ? ref.startingIndex : void 0) || this._startingIndex;
  };

  DealsApplication.prototype.nextPage = function() {
    return new this.constructor({
      params: this.params,
      pageNumber: this._pageNumber + 1
    });
  };

  DealsApplication.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsApplication.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var deals, ref, ref1, seoMetaHash;
    deals = (arg != null ? arg : {}).deals;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this.page = new Page(this._pageNumber, deals);
      Groupon.pagination = (ref = deals.metadata) != null ? ref.pagination : void 0;
      this._events.trigger('success', deals);
      this._events.stopListening();
      if (this.params) {
        DealsGTMHelper.update(this.params);
      }
      if (((ref1 = Groupon.enabledFeatures) != null ? ref1.isSEOMetadataEnabled : void 0) && (seoMetaHash = this.page.seoMetaHash)) {
        return updateSeoPageMetaHash(seoMetaHash);
      }
    }
  };

  DealsApplication.prototype.isEmptySearch = function() {
    var ref;
    return ((ref = this.page) != null ? ref.totalDealCount : void 0) === 0;
  };

  DealsApplication.prototype.isSearchedServerSide = function() {
    return this._searchedServerSide;
  };

  return DealsApplication;

})();

//# sourceMappingURL=data:application/json;base64,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
